import { CONTACTABILITY } from "../../constants/action-types";
const initialState = {
    emailStatusSummary: [],
    emailSubscriberEngagementSummary: [],
    adressCertification: [],
    clickOverTime: [],
    openOverTime: [],
    bounceOverTime: [],
    unsubscribeOverTime: [],
    consent: [],
    addressablePeople: [],
    recentEmailSendData: [],
    countBySpamLaw: [],
    highestSpamLawAuthority: '',
    explicitEmailPermissionCount: 0
}

const ContactabilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTACTABILITY.UPDATE_COUNT_BY_SPAM_LAW: {
            return Object.assign({}, state, {
                countBySpamLaw: action.payload
            });

        }
        case CONTACTABILITY.HIGHEST_SPAM_LAW_AUTHORITY: {
            return Object.assign({}, state, {
                highestSpamLawAuthority: action.payload
            });
        }
        case CONTACTABILITY.UPDATE_RECENT_EMAIL_SENDS: {
            return Object.assign({}, state, {
                recentEmailSendData: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_ADRESSABLE_PEOPLE_DATA: {
            return Object.assign({}, state, {
                addressablePeople: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_CONSENT_DATA: {
            return Object.assign({}, state, {
                consent: action.payload
            });

        }
        case CONTACTABILITY.EXPLICIT_EMAIL_PERMISSION_COUNT: {
            return Object.assign({}, state, {
                explicitEmailPermissionCount: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_CLICK_OVER_TIME: {
            return Object.assign({}, state, {
                clickOverTime: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_OPEN_OVER_TIME: {
            return Object.assign({}, state, {
                openOverTime: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_BOUNCE_OVER_TIME: {
            return Object.assign({}, state, {
                bounceOverTime: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_UNSUBSCRIBES_OVER_TIME: {
            return Object.assign({}, state, {
                unsubscribeOverTime: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_ADRESS_CERTIFICATION_SUMMARY: {
            return Object.assign({}, state, {
                adressCertification: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_EMAIL_SUBSCRIBER_ENGAGEMENT_SUMMARY: {
            return Object.assign({}, state, {
                emailSubscriberEngagementSummary: action.payload
            });

        }
        case CONTACTABILITY.UPDATE_EMAIL_STATUS_SUMMARY: {
            return Object.assign({}, state, {
                emailStatusSummary: action.payload
            });

        }



        default:
            return state
    }

}

export default ContactabilityReducer
